import "./styles/app.less";
import {load} from "./locales/load";
import {getEnvBuild} from "src/config";
import * as cookie from "src/utils/brower/cookie";

type ModuleAPP = () => void | Promise<void>;

interface ModuleItem {
    main?: ModuleAPP;
}

type Module = () => Promise<ModuleItem | undefined>;

const init = function () {
    const build = getEnvBuild();
    cookie.set("version", build.version ?? "");
}

const boot = import.meta.glob("./bootstrap/lqc.{ts,js}");

const loadModule = async function (module: Module) {
    try {
        const data = await module();
        const app = data?.main;
        if (app && typeof app === "function") {
            return app;
        }
    } catch (error) {
        console.log(error);
        // todo
    }
}

const main = async function () {
    init();
    await load();
    const promiseList: Array<Promise<ModuleAPP | undefined | void>> = [];
    for (const key in boot) {
        const module = boot[key] as Module;
        promiseList.push(loadModule(module));
    }
    const res = await Promise.all(promiseList);
    for (const app of res) {
        if (app) {
            app();
        }
    }
}

void main();
